// import { useState } from "react";
// import { PanelMenu } from "primereact/panelmenu";
import Jobs from "./Jobs";

export default function AdhocJobAdmin() {
  // const [activePage, setActivePage] = useState("Jobs");

  // const items = [
  //   {
  //     label: "Jobs",
  //     icon: "pi pi-briefcase",
  //     command: () => setActivePage("Jobs"),
  //   },
  // ];

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      {/* <aside className="w-64 bg-gray-100 border-r p-3">
        <h2 className="text-lg font-bold mb-4">Admin Panel</h2>
        <PanelMenu model={items} className="w-full" />
      </aside> */}

      {/* Right Content */}
      <main className="flex-1 px-6 overflow-auto">
        <Jobs />
        {/* <div className="bg-white p-0">{activePage === "Jobs" && <Jobs />}</div> */}
      </main>
    </div>
  );
}
